export class LoadDocument {
  id: number;
  idTemp: number;
  bytes: string;
  fileNameWithExtension: string;
  createdDate: Date;
  isActive: boolean;
}
